import { Card, CardContent, useMediaQuery } from '@mui/material';

const AuthCard = ({ children, ...props }) => {
  const isMobile = useMediaQuery('(max-width:600px)');

  return (
    <Card
      sx={{
        backgroundColor: { xs: 'rgba(255, 255, 255, 0.95)', md: '#ffffff' },
        backdropFilter: { xs: 'blur(10px)', md: 'none' },
        border: '1px solid rgba(0, 0, 0, 0.1)',
        borderRadius: 3,
        mb: 3,
        boxShadow: isMobile
          ? '0 8px 32px rgba(0, 0, 0, 0.15)'
          : '0 4px 16px rgba(0, 0, 0, 0.1)',
        ...props.sx
      }}
      {...props}
    >
      <CardContent sx={{ p: { xs: 3, sm: 4 }, ...props.cardContentSx }}>
        {children}
      </CardContent>
    </Card>
  );
};

export default AuthCard;
